import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

function Register() {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const navigate = useNavigate();

const handleSubmit = async (e) => {
  e.preventDefault();
  setError("");

  if (!name.trim()) return setError("Student name is required");
  if (!/^[0-9]{10}$/.test(phone))
    return setError("Phone must be 10 digits");
  if (!email.trim()) return setError("Email is required");
  if (!password.trim()) return setError("Password is required");

  try {
    const res = await fetch(
      "https://shuttle-craft-student-transport.onrender.com/api/students",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ name, phone, email, password }),
      }
    );

    const data = await res.json();

    console.log("API RESPONSE:", data);

    // ✅ SAVE EMAIL
    localStorage.setItem("email", email);

    // ✅ ALWAYS GO TO OTP PAGE
    navigate("/verify-otp");

  } catch (err) {
    console.error("API error:", err);

    // ✅ STILL GO OTP PAGE
    localStorage.setItem("email", email);

    navigate("/verify-otp");
  }
};

  return (
    <div className="register-wrapper">
      <div className="register-box">
        <h2>Student Registration</h2>

        {error && <p style={{ color: "red" }}>{error}</p>}

        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Student Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />

          <input
            type="text"
            placeholder="Phone Number"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />

          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <button type="submit">Register</button>
        </form>

        <p>
          Already have an account? <a href="/student-login">Sign In</a>
        </p>
      </div>
    </div>
  );
}

export default Register;
